import { useState } from 'react';
import { ContactFormData, FormStatus } from '../types/form';
import { sendContactEmail } from '../services/email';

const initialFormData: ContactFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  projectType: '',
  message: ''
};

export const useContactForm = () => {
  const [formData, setFormData] = useState<ContactFormData>(initialFormData);
  const [formStatus, setFormStatus] = useState<FormStatus>('idle');

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setTimeout(() => setFormStatus('idle'), 3000);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('sending');

    try {
      await sendContactEmail(formData);
      setFormStatus('success');
      resetForm();
    } catch (error) {
      setFormStatus('error');
      console.error('Error sending email:', error);
    }
  };

  return {
    formData,
    formStatus,
    handleInputChange,
    handleSubmit
  };
};